import { render, staticRenderFns } from "./InternationalizationDatepicker.vue?vue&type=template&id=48636610"
import script from "./InternationalizationDatepicker.vue?vue&type=script&lang=js"
export * from "./InternationalizationDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports